import { Box, Typography, styled, CircularProgress } from "@mui/material";
import { CustomFormSwitch } from "@/components/custom/custom-form-switch";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggle2Fa } from "@/services/users.service";
import { useDispatch } from "react-redux";
import { showToast } from "@/redux/actions/toast-actions";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),

  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
  },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,

  [theme.breakpoints.up("lg")]: {
    width: 256,
  },
}));

const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const TwoFactorAuth = ({ data }) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const is2faEnabled = Boolean(data?.["2fa"]);

  const { mutate: toggle2faMutate, isPending } = useMutation({
    mutationFn: () => toggle2Fa(data?.id),
    onSuccess: (response) => {
      dispatch(
        showToast(
          response?.message ??
            `Two factor authentication ${is2faEnabled ? "disabled" : "enabled"}`,
          "success",
        ),
      );
      queryClient.invalidateQueries({ queryKey: ["admin-user"] });
    },
    onError: (err) => {
      dispatch(showToast(err?.message ?? "Failed to toggle 2FA", "error"));
    },
  });

  const handleToggle = () => {
    if (isPending) return;
    toggle2faMutate();
  };

  return (
    <Wrapper>
      <Row>
        <Side>
          <Typography fontWeight={500} fontSize={18}>
            Two Factor Auth
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Toggle 2FA here
          </Typography>
        </Side>

        <Content>
          <Box display="flex" alignItems="center" gap={1}>
            <CustomFormSwitch
              name="twoFactorEnabled"
              label={is2faEnabled ? "Enabled" : "Disabled"}
              checked={is2faEnabled}
              onChange={handleToggle}
              disabled={isPending}
            />
            {isPending && <CircularProgress size={16} thickness={5} />}
          </Box>
        </Content>
      </Row>
    </Wrapper>
  );
};